import { PhoneNumberWithPrefixResponse } from '../api/responses/phone-number-with-prefix.response';
import { PhoneNumberWithPrefix } from '../containers/phone-number-with-prefix/phone-number-with-prefix';

export const phoneNumberWithPrefixFromResponse = (
  response: PhoneNumberWithPrefixResponse,
): PhoneNumberWithPrefix => {
  return new PhoneNumberWithPrefix({
    number: response.number,
    prefix: response.prefix,
  });
};
